import BaseApi from './baseApi';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { v4 as uuidv4 } from 'uuid';
export default class UploadServiceApi extends BaseApi {
    constructor(page: string) {
        super("FTP", page);
    }
  
    async UploadDocuments(formData : FormData) : Promise<string[]> {
        const response = await this.api.post('UploadFile', formData);
        if (!response) return [];
        if (response.isSuccess) {
            var urls: string[];
            urls = response.data as string[];
            return urls;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async DownloadDocuments(file: string, fileName: string) : Promise<void> {
        const response = await this.api.getRaw("DownloadFiles", { file: file }, { responseType: "arraybuffer" });
        // if (!response) return;
        
        if (!response) return;
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }

    async DownloadZip(files: string[], zipFileName: string, format: string = "jpg") : Promise<void> {
        const zip = new JSZip();
        for (const element of files) {
            try {
                const response = await this.api.getRaw("DownloadFiles", { file: element }, { responseType: "arraybuffer" });
                if (!response) return;

                const blob = new Blob([response.data], { type: "application/octet-stream" });
                const guid = uuidv4();
                zip.file(guid + "." + format, blob);
            } catch (error) {
                console.error("Error downloading file:", element, error);
            }
        }

        try {
            // ✅ Workaround Safari + TypeScript
            const content = await zip.generateAsync({ type: "uint8array" });
            const blob = new Blob([new Uint8Array(content)], { type: "application/zip" });

            saveAs(blob, zipFileName + ".zip");
        } catch (zipError) {
            console.error("Error creating ZIP file:", zipError);
        }
    }

    async DownloadPictures(file: string) : Promise<string> {
        const response = await this.api.getRaw("DownloadFiles", { file: file }, { responseType: "arraybuffer" });
        if (!response) return "";
        
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        return url;
    }
}
